// Inline-SVG flags — no external assets, and unlike emoji flags (🇩🇪/🇬🇧) these
// render consistently on every OS (Windows does not draw regional-indicator
// emoji as flags). Same shapes as Flixpector's, so the switch reads identically
// in both apps.

interface FlagProps {
  size?: number
}

/** German tricolour (black / red / gold), 5:3 ratio. */
export function FlagDE({ size = 18 }: FlagProps) {
  const height = Math.round((size * 3) / 5)
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 5 3"
      role="img"
      aria-hidden="true"
      style={{ borderRadius: 2, display: 'block', flexShrink: 0 }}
    >
      <rect width="5" height="1" y="0" fill="#000000" />
      <rect width="5" height="1" y="1" fill="#DD0000" />
      <rect width="5" height="1" y="2" fill="#FFCE00" />
    </svg>
  )
}

/** Union Jack (used to signal English), 2:1 ratio. */
export function FlagEN({ size = 18 }: FlagProps) {
  const height = Math.round(size / 2)
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 60 30"
      role="img"
      aria-hidden="true"
      style={{ borderRadius: 2, display: 'block', flexShrink: 0 }}
    >
      <clipPath id="fx-flag-en-counterchange">
        <path d="M30,15 h30 v15 z M30,15 v15 h-30 z M30,15 h-30 v-15 z M30,15 v-15 h30 z" />
      </clipPath>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath="url(#fx-flag-en-counterchange)"
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  )
}
